import React, { useContext, useEffect, useState } from "react";
import * as Sentry from "@sentry/react";
import { useParams } from "react-router-dom";
import { RootStoreContext } from "src/stores/RootStore";
import * as Screens from "src/screens";
import { UI } from "@wwimmo/ui";
import { runInAction } from "mobx";
import { observer } from "mobx-react";
import axios from "axios";
import { NetworkConfig } from "src/network/NetworkConfig";
import { Step } from "src/screens/process/step/Step";
import { STEP_TYPES } from "src/api/Processes";
import { SelectComponent } from "src/api/Select";
import { Tiles } from "src/components/tile";
import { useTranslation } from "react-i18next";
import { Route, selectRoute } from "src/config/routes";
import { getLang } from "src/utils/i18n";

const SelectBase = () => {
    const { t } = useTranslation();
    const { navStore, uiStore, easyContactStore } = useContext(RootStoreContext);
    const [isLoading, setIsLoading] = useState<Boolean>(true);
    const { processId, stepId } = useParams<{ processId: string; stepId: string }>();
    const step = easyContactStore.getStepById(processId, stepId);

    useEffect(() => {
        if (step?.parameters?.rootcomponent) {
            axios.get(`${NetworkConfig.getComponentsUrl}/${step.parameters.rootcomponent}`).then((response) => {
                setIsLoading(false);
                runInAction(() => {
                    easyContactStore.setSelectComponent(response.data.ec_components as SelectComponent[]);
                });
            });
        }
    }, [navStore, easyContactStore, step, setIsLoading, uiStore]);

    if (!step) {
        return <Screens.Error message={t("error.invalid-data")} />;
    }
    if (!step.parameters?.rootcomponent) {
        return <Screens.Error message={t("error.invalid-data")} />;
    }

    return (
        <Step>
            <UI.Container className="pt-4 flex-grow-1 d-flex flex-column justify-content-start">
                <UI.Row>
                    {!easyContactStore.selectComponent || isLoading ? (
                        <UI.Col className="text-center">
                            <UI.RotatingSpinner />
                        </UI.Col>
                    ) : (
                        <UI.Col lg={{ span: 8, offset: 2 }} sm={{ span: 10, offset: 1 }}>
                            <Tiles.Container>
                                {easyContactStore.selectComponent.map((component, index) => {
                                    const label = component.component_mls.find(
                                        (component) => component.language === getLang()
                                    )?.title;

                                    return (
                                        <Tiles.Tile
                                            key={component.id}
                                            id={component.id}
                                            icon={component.icon}
                                            label={label ?? ""}
                                            index={index}
                                            to={selectRoute(Route.selectComponent, {
                                                processId,
                                                stepType: String(STEP_TYPES.SELECT),
                                                stepId,
                                                componentId: component.id
                                            })}
                                        />
                                    );
                                })}
                            </Tiles.Container>
                        </UI.Col>
                    )}
                </UI.Row>
            </UI.Container>
        </Step>
    );
};

export const Select = Sentry.withProfiler(observer(SelectBase));
